var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.langs,"label":_vm._f("cap")(_vm.$t('language')),"menu-props":"auto","prepend-icon":"translate","hide-details":"","return-object":""},on:{"input":function($event){_vm.$emit('update:lang', _vm.langModel.value)}},model:{value:(_vm.langModel),callback:function ($$v) {_vm.langModel=$$v},expression:"langModel"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa4d0818","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSwitchLang.vue
// module id = null
// module chunks = 